import React from "react";
import { useTranslation } from "react-i18next";
import gifImage from "../assets/img/tbilisi_smooth_transition.gif";
import horticultureImg from "../assets/img/horticulture_vid.gif";
import fashionForwardImg from "../assets/img/fashion_forward_vid.gif";
import homeGoodsImg from "../assets/img/home_goods_vid.gif";
import dynamicPricingImg from "../assets/img/dynamic_pricing_vid.gif";
import hrSolutionsImg from "../assets/img/hr_solutions_vid.gif";
import legalSolutionsImg from "../assets/img/legal_solutions_vid.gif";
import energyTradingImg from "../assets/img/energy_trading_vid.gif";
import agriRoboticsImg from "../assets/img/Agri_Robotics_vid.gif";
import { Link } from "react-router-dom";


// Map of images to link dynamically based on translation keys
const imageMap: { [key: string]: string } = {
    "horticulture_vid.gif": horticultureImg,
    "fashion_forward_vid.gif": fashionForwardImg,
    "home_goods_vid.gif": homeGoodsImg,
    "dynamic_pricing_vid.gif": dynamicPricingImg,
    "hr_solutions_vid.gif": hrSolutionsImg,
    "legal_solutions_vid.gif": legalSolutionsImg,
    "energy_trading_vid.gif": energyTradingImg,
    "Agri_Robotics_vid.gif": agriRoboticsImg
};

const Home = () => {
    const { t } = useTranslation();
    
    const serviceCards = t('services.cards', { returnObjects: true }) as Array<{
        title: string;
        subtitle: string;
        description: string;
        image: string;
      }>;

    // Retrieve pricing plans from translations and cast them as an array
    const pricingPlans = t('pricing.plans', { returnObjects: true }) as Array<{
        name: string;
        details: string;
        price: string;
        link?: string;
    }>;

    return (
    <>

        {/* Hero Section */}
        <header
            className="header-2"
            style={{
            backgroundImage: `url(${gifImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
        >
        <div className="page-header min-vh-75 d-flex align-items-center justify-content-center">
            <div className="container text-center">
            <h1 id="hero-headline" className="text-white">{t('hero.headline')}</h1>
            <p id="hero-subheadline" className="lead text-white mt-3">
                {t('hero.subheadline')}
            </p>
            <Link id="hero-button" to="/contact-us" className="btn btn-lg btn-primary mt-4">
                {t('hero.button')}
            </Link>
            </div>
        </div>
        </header>

        {/* Features Section */}
        <section id="features" className="py-7 bg-light">
        <div className="container text-center">
            <h2 id="why-headline" className="mb-5">{t('whyUs.headline')}</h2>
            <div className="row">
            <div className="col-md-4">
                <h1 className="text-primary">
                <i className="fas fa-cogs"></i>
                </h1>
                <h5 id="why-scalable-title" className="font-weight-bold">
                    {t('whyUs.features.scalable.title')}
                </h5>
                <p id="why-scalable-desc">
                    {t('whyUs.features.scalable.description')}
                </p>
            </div>
            <div className="col-md-4">
                <h1 className="text-primary">
                <i className="fas fa-lock"></i>
                </h1>
                <h5 id="why-secure-title" className="font-weight-bold">
                    {t('whyUs.features.secure.title')}
                </h5>
                <p id="why-secure-desc">
                    {t('whyUs.features.secure.description')}
                </p>
            </div>
            <div className="col-md-4">
                <h1 className="text-primary">
                <i className="fas fa-code"></i>
                </h1>
                <h5 id="why-developer-title" className="font-weight-bold">
                    {t('whyUs.features.developer.title')}
                </h5>
                <p id="why-developer-desc">
                    {t('whyUs.features.developer.description')}
                </p>
            </div>
            </div>
        </div>
        </section>

        {/* Services Section */}
        <section id="services" className="pb-5 position-relative bg-gradient-dark mx-n3">
            <div className="container">

                <div className="row">
                {serviceCards.map((card, index) => (
                    <div key={index} className="col-lg-6 col-12">
                    <div className="card card-profile mt-4">
                        <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mt-n5">
                            <div className="p-3 pe-md-0">
                            <img
                                className="w-100 border-radius-md shadow-lg pop-up-effect"
                                src={imageMap[card.image]}
                                alt={card.title}
                                loading="lazy"
                            />
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6 col-12 my-auto" style={{ height: "250px", overflow: "auto" }}>
                            <div className="card-body ps-lg-0">
                            <h5 id={`service-title-${index}`} className="mb-0">{card.title}</h5>
                            <h6 id={`service-subtitle-${index}`} className="text-info">{card.subtitle}</h6>
                            <p id={`service-description-${index}`} className="mb-0">{card.description}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                ))}
                </div>

            </div>
        </section>

        {/* Pricing Section */}
        <section id="pricing" className="py-5 bg-light">
            <div className="container text-center">
                <h2 id="pricing-title" className="mb-5">
                    {t('pricing.title')}
                </h2>
                <div className="row">
                {Array.isArray(pricingPlans) && pricingPlans.map((plan, index) => (
                    <div key={index} className="col-md-4">
                        <div className="card shadow-sm mb-4 h-100">
                            <div className="card-body">
                                <h5 id={`pricing-name-${index}`} className="font-weight-bold">{plan.name}</h5>
                                <p id={`pricing-details-${index}`} className="card-text">{plan.details}</p>
                                {plan.link ? (
                                    <Link 
                                    id={`pricing-price-${index}`} 
                                    to={plan.link} 
                                    className="btn btn-primary">
                                    {plan.price}
                                    </Link>
                                ) : (
                                    <h4 id={`pricing-price-${index}`} className="text-primary">{plan.price}</h4>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </section>
           
    </>
  );
};

export default Home;
